import React from "react";

const tips = {
  creditLimit: (
    <div>
      <strong>Credit limit</strong> is the maximum amount that you can borrow on your card without a
      penalty.
    </div>
  ),
  apr: (
    <div>
      <strong>Annual Percentage Rate</strong> (APR) is the interest rate – the cost of borrowing
      money on your card.
    </div>
  ),
  annualFee: (
    <div>
      <strong>Annual fee</strong> is the amount you have to pay each year in order to use the card.
    </div>
  ),
  rewards: (
    <div>
      <strong>Rewards</strong> are additional perks that may come with a card. 1% cash back would be
      a 1% refund on all purchases.
    </div>
  )
};

export default tips;
